module.exports = __webpack_public_path__ + "static/assets/227598e595f11ea77afb97fdc79b769c.gif";